import type { ClinicContactLink } from '@secretario/shared';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { CLINIC_ON } from './edition.js';
import { useHasClinic } from './clinicGate.js';

/**
 * Contatos que também são pacientes da clínica (fase E, decisão 3): lidos da clínica na
 * hora, sem cópia. Só para quem faz parte de uma clínica; no pacote da loja, nada.
 */
export const PATIENT_LINKS_KEY = ['clinic', 'contact-links'] as const;

export function usePatientLinks() {
  const hasClinic = useHasClinic();
  const query = useQuery({
    queryKey: PATIENT_LINKS_KEY,
    queryFn:
      import.meta.env.VITE_CLINIC === 'off'
        ? async (): Promise<ClinicContactLink[]> => []
        : () => import('./api/clinic.js').then((m) => m.getClinicContactLinks()),
    enabled: CLINIC_ON && hasClinic,
    staleTime: 60_000,
    retry: false,
  });
  const list = useMemo(() => query.data ?? [], [query.data]);
  const byContact = useMemo(() => new Map(list.map((row) => [row.contactId, row])), [list]);
  return { list, byContact };
}

/** Valor do chip "Pacientes" (não é categoria do contato: é a lista lida da clínica). */
export const PATIENT_FILTER = '__pacientes';
